import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";

const EndModal = props => {
  const closeBtn = props.onHide;

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header closeButton style={{ paddingBottom: "0" }}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{ fontSize: "2em" }}
        >
          {props.content.mainTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          textAlign: "center",
          fontSize: "1.5em",
          fontWeight: "700",
          lineLeight: "1.2em",
          margin: "1em auto",
          width: "80%",
        }}
      >
        {props.content.subTitle}
      </Modal.Body>
      <Modal.Footer>
        {props.content.btnText === "완료" ? (
          <Button onClick={closeBtn}>{props.content.btnText}</Button>
        ) : (
          <a href="https://play.google.com/store/apps/details?id=com.sinor_app_front">
            <Button style={{ width: "100%", padding: "1em" }}>
              {props.content.btnText}
            </Button>
          </a>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default EndModal;
